import { callback } from './instances';

export default ($el) => {
    if ($el.$children) {
        return $el.$children;
    }

    return $el.$children = (componentName = null) => {
        return callback(componentName, $el);
    };
};